/* Elaine Presente — Spotify Code automático (FRENTE 836886 + QUADRO 1289167 Spotify 1–7).
   música (song-search) -> SVG público scannables.scdn.co -> PNG transparente (cor/tamanho do contrato)
   -> upload no campo oculto tee-photo-<layer> do widget Teeinblue -> confirma na customization
   -> só então libera "Finalizar meu presente" / "Comprar agora".
   Contratos: src/elaine_agent/products/front_models.py, frame_models.py, mvp/catalog.py (A1.15–A1.26).
   Modo (definido em snippets/astron-params.liquid): window.ELAINE_SPOTIFY_AUTO_MODE = 'off' | 'on'.
     'off' -> inativo, exceto nesta aba com ?elaine_spotify=test (desliga com ?elaine_spotify=off).
     ?elaine_spotify=test-fail simula falha na geração (só para homologação).
   Rollback: remover o bloco ELAINE-SPOTIFY-AUTO de snippets/astron-params.liquid. */
(function () {
  'use strict';
  var KEY = 'elaineSpotifyAuto';
  var mode = String(window.ELAINE_SPOTIFY_AUTO_MODE || 'off');
  var test = null;
  try {
    var q = new URLSearchParams(location.search).get('elaine_spotify');
    if (q === 'off') sessionStorage.removeItem(KEY);
    else if (q === 'test' || q === 'test-fail') sessionStorage.setItem(KEY, q);
    test = sessionStorage.getItem(KEY);
  } catch (e) { /* storage bloqueado: segue o modo global */ }
  if (mode !== 'on' && !test) return;
  var SIMULATE_FAIL = test === 'test-fail';

  var SCALE = 3, NS = 'http://www.w3.org/2000/svg';
  var FILL = { BLACK: '#000000', WHITE: '#FFFFFF' };
  var FRONT = { artwork: '836886', template: 'template-542572' };
  var FRAME = { artwork: '1289167', template: 'template-696386', selector: 'layer-960604' };
  // song = layer song-search; code = layer photo oculta (tib-spotify-code-auto); w/h = caixa da layer; color = cor do código
  var TARGETS = [
    { name: 'Frente', part: FRONT, sel: null, song: 'layer-755699', code: 'layer-517390', color: 'BLACK', w: 488.2, h: 82.1 },
    { name: 'Quadro', part: FRAME, sel: '30979679', song: 'layer-285495', code: 'layer-820447', color: 'BLACK', w: 820.36, h: 139.83 },
    { name: 'Quadro', part: FRAME, sel: '30979680', song: 'layer-703315', code: 'layer-590247', color: 'WHITE', w: 826, h: 140 },
    { name: 'Quadro', part: FRAME, sel: '30979681', song: 'layer-825329', code: 'layer-603497', color: 'BLACK', w: 826, h: 139 },
    { name: 'Quadro', part: FRAME, sel: '30979682', song: 'layer-532968', code: 'layer-614208', color: 'WHITE', w: 826, h: 139 },
    { name: 'Quadro', part: FRAME, sel: '30979683', song: 'layer-598927', code: 'layer-472906', color: 'BLACK', w: 648, h: 109 },
    { name: 'Quadro', part: FRAME, sel: '30979684', song: 'layer-654923', code: 'layer-785203', color: 'WHITE', w: 648, h: 109 },
    { name: 'Quadro', part: FRAME, sel: '30979685', song: 'layer-435849', code: 'layer-326914', color: 'WHITE', w: 1373, h: 230 }
  ];
  var MAX_AUTO_TRIES = 2;
  var state = { mode: mode, test: test, busy: false, current: null, error: null, tries: {}, log: [] };
  window.__elaineSpotifyAuto = state;

  // customerUploadId -> "layer|música" dos códigos que este script gerou. Fica no localStorage porque o widget
  // sincroniza a customization entre abas e recarregamentos: assim um código gerado em outra aba (ou antes do
  // reload) para a mesma música é reconhecido e não é gerado de novo. O valor ws:… muda sozinho para _large; o id não.
  var MAP_KEY = 'elaineSpotifyCodesV1', memMap = {};
  function codes() { try { return JSON.parse(localStorage.getItem(MAP_KEY) || '{}'); } catch (e) { return memMap; } }
  function remember(uid, tag) {
    var m = codes(); m[uid] = tag; memMap[uid] = tag;
    var keys = Object.keys(m); if (keys.length > 60) keys.slice(0, keys.length - 60).forEach(function (k) { delete m[k]; });
    try { localStorage.setItem(MAP_KEY, JSON.stringify(m)); } catch (e) { /* segue com memMap */ }
  }

  function log(msg) {
    state.log.push(new Date().toISOString().slice(11, 19) + ' ' + msg);
    if (state.log.length > 50) state.log.shift();
    if (test) { try { console.log('[elaine-spotify]', msg); } catch (e) {} }
  }
  function cust() { try { return (window.teeinblue && teeinblue.getCurrentCustomization()) || {}; } catch (e) { return {}; } }
  function px(x) { return Math.floor(x * SCALE + 0.5); }   // round-half-up, mesma regra do output_size() do gerador Python

  // id da faixa: `id` do objeto song-search é a fonte de verdade; url/uri só se o id faltar; divergência -> erro
  function trackId(v) {
    if (!v) return null;
    if (typeof v === 'string') { try { v = JSON.parse(v); } catch (e) { v = { url: v }; } }
    var id = typeof v.id === 'string' && /^[0-9A-Za-z]{22}$/.test(v.id) ? v.id : null;
    var m = String(v.url || v.uri || '').match(/track[:/]([0-9A-Za-z]{22})/);
    var other = m ? m[1] : null;
    if (id && other && id !== other) return 'MISMATCH';
    return id || other;
  }

  // alvo ativo = template Spotify escolhido (+ modelo do quadro) + música escolhida + campo de upload presente
  function activeTargets() {
    var c = cust(), out = [];
    TARGETS.forEach(function (t) {
      if (c[t.part.artwork] !== t.part.template) return;
      if (t.sel && String(c[FRAME.selector]) !== t.sel) return;
      var id = trackId(c[t.song]);
      if (!id) return;
      out.push({ t: t, id: id, ready: id !== 'MISMATCH' && !!c[t.code] && codes()[String(c[t.code + '-upload-id'])] === t.code + '|' + id,
                 input: document.getElementById('tee-photo-' + t.code) });
    });
    return out;
  }

  function fetchText(url, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, ms);
    return fetch(url, { credentials: 'omit', signal: ctl ? ctl.signal : undefined }).then(function (r) {
      clearTimeout(timer);
      if (!r.ok) throw new Error('scannables HTTP ' + r.status);
      return r.text();
    }, function (e) { clearTimeout(timer); throw e; });
  }

  async function makePng(id, t) {
    if (SIMULATE_FAIL) throw new Error('falha simulada (homologação)');
    var W = px(t.w), H = px(t.h), fill = FILL[t.color];
    var text = await fetchText('https://scannables.scdn.co/uri/plain/svg/FFFFFF/black/640/spotify:track:' + id, 15000);
    var svg = new DOMParser().parseFromString(text, 'image/svg+xml').documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg') throw new Error('SVG inválido');
    var vb = (svg.getAttribute('viewBox') || '').split(/[\s,]+/).map(Number);
    var bars = 0;
    [].slice.call(svg.querySelectorAll('rect')).forEach(function (el) {
      var bg = ['x', 'y', 'width', 'height'].every(function (k, i) { return Number(el.getAttribute(k) || 0) === vb[i]; });
      if (bg) el.remove(); else { el.setAttribute('fill', fill); bars++; }           // fundo descartado; só o código
    });
    [].slice.call(svg.querySelectorAll('path')).forEach(function (el) { el.setAttribute('fill', fill); });
    if (bars < 10) throw new Error('SVG sem barras de Spotify Code');
    var host = document.createElementNS(NS, 'svg');                                   // bbox justo (sem padding)
    host.setAttribute('style', 'position:absolute;left:-9999px;top:0;width:640px;height:160px');
    var node = document.importNode(svg, true);
    host.appendChild(node); document.body.appendChild(host);
    var bb = node.getBBox(); host.remove();
    if (!bb.width || !bb.height) throw new Error('SVG sem área');
    svg.setAttribute('viewBox', [bb.x, bb.y, bb.width, bb.height].join(' '));
    var s = Math.min(W / bb.width, H / bb.height), dw = bb.width * s, dh = bb.height * s;   // CONTAIN centralizado
    svg.setAttribute('width', dw); svg.setAttribute('height', dh);
    var url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    var img = new Image();
    try { await new Promise(function (ok, ko) { img.onload = ok; img.onerror = function () { ko(new Error('render do SVG falhou')); }; img.src = url; }); }
    finally { URL.revokeObjectURL(url); }
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    cv.getContext('2d').drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
    var blob = await new Promise(function (ok) { cv.toBlob(ok, 'image/png'); });
    if (!blob || blob.size < 500) throw new Error('PNG vazio');
    return new File([blob], 'spotify-code-' + t.code + '-' + id + '.png', { type: 'image/png' });
  }

  async function upload(file, a) {
    var input = a.input || document.getElementById('tee-photo-' + a.t.code);
    if (!input) throw new Error('campo do código ausente');
    var before = String(cust()[a.t.code + '-upload-id'] || '');
    var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    for (var i = 0; i < 60; i++) {                                                    // até 30 s
      await new Promise(function (ok) { setTimeout(ok, 500); });
      var c = cust(), now = c[a.t.code], uid = String(c[a.t.code + '-upload-id'] || '');
      if (typeof now === 'string' && now.indexOf('customers/uploads/') !== -1 && uid && uid !== before) return uid;
    }
    throw new Error('upload não confirmado em 30 s');
  }

  async function tick(force) {
    if (state.busy || !window.teeinblue) return;
    var act = activeTargets();
    render(act);
    var next = act.filter(function (a) {
      if (a.ready || a.id === 'MISMATCH' || !a.input) return false;
      return force || (state.tries[a.t.code + ':' + a.id] || 0) < MAX_AUTO_TRIES;
    })[0];
    if (!next) return;
    var k = next.t.code + ':' + next.id;
    state.tries[k] = (state.tries[k] || 0) + 1;
    state.busy = true; state.current = next.t.name; state.error = null;
    render(activeTargets());
    try {
      log(next.t.name + ' ' + next.t.code + ' música ' + next.id);
      var uid = await upload(await makePng(next.id, next.t), next);
      if (trackId(cust()[next.t.song]) === next.id) {                                // música não mudou durante o envio
        remember(uid, next.t.code + '|' + next.id);
        delete state.tries[k];
        log(next.t.name + ' código enviado upload ' + uid);
      }
    } catch (e) {
      state.error = next.t.name + ': ' + String(e && e.message || e);
      log('ERRO ' + state.error);
    } finally {
      state.busy = false; state.current = null;
      render(activeTargets());
    }
  }

  function isFailed(a) { return a.id === 'MISMATCH' || !a.input || (state.tries[a.t.code + ':' + a.id] || 0) >= MAX_AUTO_TRIES; }
  function pending(act) { return state.busy || act.some(function (a) { return !a.ready; }); }

  // ---------- trava dos botões de compra (só quando há Spotify Code ativo sem código pronto) ----------
  function atcSelector() {
    return [(window.teeinblue && teeinblue.atcSubmitSelector) || '', '.product-form__cart-submit', '.buttonBuyNow', 'button[name="add"]']
      .filter(Boolean).join(',');
  }
  function isBuy(el) { try { return !!(el && el.closest && el.closest(atcSelector())); } catch (e) { return false; } }
  function guard(ev) {
    var act = activeTargets();
    if (!act.length || !pending(act)) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var failed = act.some(function (a) { return !a.ready && isFailed(a); });
    toast(failed ? 'Não foi possível gerar o código Spotify da música escolhida. Toque em "Tentar novamente" ou escolha a música de novo.'
                 : 'Gerando o código Spotify da sua música… aguarde alguns segundos.');
    var box = document.querySelector('.elaine-spotify-status');
    if (box) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
  window.addEventListener('click', function (ev) { if (isBuy(ev.target)) guard(ev); }, true);
  window.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (f && f.action && /\/cart\/add/.test(f.action) && f.querySelector(atcSelector())) guard(ev);
  }, true);

  // ---------- UI ----------
  var toastTimer = 0;
  function toast(msg) {
    var n = document.getElementById('elaine-spotify-wait');
    if (!n) {
      n = document.createElement('div'); n.id = 'elaine-spotify-wait'; n.setAttribute('role', 'alert');
      n.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);max-width:90vw;background:#222;color:#fff;padding:10px 16px;border-radius:8px;z-index:99999;font:14px/1.4 sans-serif;text-align:center';
      document.body.appendChild(n);
    }
    n.textContent = msg; n.style.display = 'block';
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { n.style.display = 'none'; }, 4000);
  }

  function render(act) {
    [].slice.call(document.querySelectorAll(atcSelector())).forEach(function (b) {
      var lock = act.length > 0 && pending(act);
      b.style.opacity = lock ? '0.5' : ''; b.setAttribute('aria-busy', lock ? 'true' : 'false');
    });
    act.forEach(function (a) {
      var field = document.getElementById('tee-field--' + a.t.song);
      if (!field) return;
      var id = 'elaine-spotify-status-' + a.t.code, box = document.getElementById(id);
      if (!box) {
        box = document.createElement('div'); box.id = id; box.className = 'elaine-spotify-status'; box.setAttribute('aria-live', 'polite');
        box.style.cssText = 'margin:6px 0 2px;font:13px/1.4 sans-serif';
        field.appendChild(box);
      }
      var failed = isFailed(a);
      var html = a.ready ? '<span style="color:#2e7d32">✓ Código Spotify gerado para esta música</span>'
        : (state.busy && state.current === a.t.name) || !failed ? '<span style="color:#555">Gerando o código Spotify desta música…</span>'
        : '<span style="color:#b00020">Não foi possível gerar o código Spotify.</span> <button type="button" data-elaine-retry="1" style="margin-left:6px;padding:2px 10px;border:1px solid #b00020;border-radius:6px;background:#fff;color:#b00020;cursor:pointer">Tentar novamente</button>';
      if (box.getAttribute('data-html') !== html) { box.innerHTML = html; box.setAttribute('data-html', html); }
    });
    [].slice.call(document.querySelectorAll('.elaine-spotify-status')).forEach(function (b) {
      var code = b.id.replace('elaine-spotify-status-', '');
      if (!act.some(function (a) { return a.t.code === code; })) b.remove();          // template/modelo trocado
    });
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('[data-elaine-retry]');
    if (!b) return;
    ev.preventDefault();
    state.tries = {}; state.error = null; log('tentar novamente');
    tick(true);
  });

  log('ativo modo=' + mode + (test ? ' teste=' + test : ''));
  setInterval(function () { if (document.querySelector('[id^="tee-field--"]')) tick(false); }, 700);
})();
